import { createSlice } from '@reduxjs/toolkit';

import type { Pattern } from '../types/pattern';
import type { PatternSchema } from '../types/pattern.schema';

const initialState: PatternSchema = {
    selectedPattern: null,
};

const patternSlice = createSlice({
    name: 'pattern',
    initialState,
    reducers: {
        setSelectedPattern: (
            state,
            { payload }: { payload: Pattern | null },
        ) => {
            state.selectedPattern = payload;
        },
    },
});

export const {
    actions: { setSelectedPattern },
    reducer: patternReducer,
} = patternSlice;
